// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"132":"reception","571":"settings","805":"transactions","992":"reports"}[chunkId] + "." + {"132":"9a461975","571":"102fa1b5","805":"65de22f3","992":"bbb91047"}[chunkId] + ".css";
};